import { Component, AfterViewInit, AfterContentInit, OnDestroy, Input } from '@angular/core';

// animations
import { fade } from 'src/app/core/animations/fade';

@Component({
  selector: 'app-overlay-container',
  templateUrl: './overlay-container.component.html',
  styleUrls: ['./overlay-container.component.scss'],
  animations: [fade]
})
export class OverlayContainerComponent implements AfterViewInit, AfterContentInit, OnDestroy {
  
  // Inputs
  /**
   * 
   */
  @Input({ alias: 'classList' }) public ClassList: string = null

  constructor() {}

  ngAfterViewInit(): void {
    document.body.classList.add('overflow-hidden')
  }

  ngAfterContentInit(): void {}
  
  ngOnDestroy(): void {
    document.body.classList.remove('overflow-hidden')
  }   

}
